import { Form, FormikProps } from 'formik';
import cx from './common.module.scss';
import { InputField } from 'src/components/common/formFields';
import ErrorMessage from 'src/components/common/formFields/errorMessage/ErrorMessage';
import SelectField, { TSelectOptions } from 'src/components/common/formFields/selectField/SelectField';
import TextEditorAreaDescriptive from 'src/components/common/formFields/textEditorAreaDescriptive/TextAreaDescriptive';
import { componentSizeVariantsEnum } from 'src/constants';
import { CoWorkerList, IncubatorList, SelectedIndustries } from 'src/constants/user.constants';
import { enumToJson } from 'src/utils';
import Label from 'src/components/common/formFields/label/Label';
import SuggestionSelectField from 'src/components/common/formFields/suggestionSelectField/suggestionSelectField';

function BasicInfo({ values, setFieldValue, touched, errors }: FormikProps<any>) {
    const ventureStageOptions: TSelectOptions[] = [
        {
            label: 'Idea',
            value: 'Idea',
            id: 'Idea'
        },
        {
            label: 'Prototype',
            value: 'Prototype',
            id: 'Prototype'
        },
        {
            label: 'Early Traction',
            value: 'Early Traction',
            id: 'Early Traction'
        },
        {
            label: 'Scaling',
            value: 'Scaling',
            id: 'Scaling'
        }
    ]
    const fundingStageOptions: TSelectOptions[] = [
        {
            label: 'Bootstrap',
            value: 'Bootstrap',
            id: 'Bootstrap'
        },
        {
            label: 'Pre Seed',
            value: 'Pre Seed',
            id: 'Pre Seed'
        },
        {
            label: 'Seed',
            value: 'Seed',
            id: 'Seed'
        },
        {
            label: 'Series A & onwards',
            value: 'Series A Onwards',
            id: 'Series A Onwards'
        }
    ]
    const industriesOptions: TSelectOptions[] = enumToJson({
        enumData: SelectedIndustries
    })?.map((item) => item?.label === 'Others' ? ({ ...item, label: 'Others (specify)', value: 'Others' }) : item);
    const modifiedIncubatorList = IncubatorList?.map((item) => {
        return { id: item?.Name, label: item?.Name === 'Others' ? 'Others (Please specify)' : item?.Name, value: item?.Name }
    })
    const incubatorValue = modifiedIncubatorList.find((item) => item.value === values.incubatorName)?.label
    const modifiedCoworkingList = CoWorkerList?.map((item) => {
        return { id: item?.Name, label: item?.Name === 'Others' ? 'Others (Please specify)' : item?.Name, value: item?.Name }
    })
    const coWorkingValue = modifiedCoworkingList.find((item) => item.value === values.coWorkingName)?.label

    return (
        <>
            <p className={cx.hint}>Your venture will be showcased in venture verse</p>
            <InputField
                label='Venture/Idea name (suggested characters 50)'
                id="title"
                value={values?.title}
                variant={componentSizeVariantsEnum.SMALL}
                placeholder={`Title`}
                type="text"
                required
                isTouched={typeof touched.title === 'boolean' ? touched.title : false}
                errorMessage={typeof errors?.title === 'string' ? errors.title : undefined}
            />
            <InputField
                label="What's your big idea or startup about? (suggested characters 90)"
                id="description"
                value={values?.description}
                variant={componentSizeVariantsEnum.SMALL}
                placeholder="Describe Your Venture in One line"
                type="text"
                required
                isTouched={typeof touched.description === 'boolean' ? touched.description : false}
                errorMessage={typeof errors?.description === 'string' ? errors.description : undefined}
            />
            <div className='input-field-component__labelBox'>
                <Label htmlFor='About' variant={componentSizeVariantsEnum.SMALL} required={true}>
                    Describe your Venture/Idea
                </Label>
            </div>
            <TextEditorAreaDescriptive
                variant={componentSizeVariantsEnum.SMALL}
                id="about"
                value={values.about}
                onChange={(e) => {
                    const value = e.target.value;
                    setFieldValue('about', value);
                }}
            />
            {touched.about && errors.about && (
                <ErrorMessage message="about is required" className='mt-3' />
            )}
            <div className='mt-3'>
                <SelectField
                    placeholder='Select a industry'
                    id='domain'
                    variant={componentSizeVariantsEnum.SMALL}
                    required title='domain'
                    label='Domain'
                    onSelection={(item: any) => setFieldValue('domain', item.value)}
                    selectedValue={values.domain}
                    options={industriesOptions}
                    isTouched={typeof touched.domain === 'boolean' ? touched.domain : false}
                    errorMessage={typeof errors?.domain === 'string' ? errors.domain : undefined}
                />
            </div>

            {values?.domain === 'Others' && (
                <InputField
                    label="Other Domain Name"
                    id="otherDomainInput"
                    value={values?.otherDomainInput}
                    variant={componentSizeVariantsEnum.SMALL}
                    placeholder="Enter Domain Name"
                    type="text"
                    required={values?.domain === 'Others'}
                    isTouched={typeof touched.otherDomainInput === 'boolean' ? touched.otherDomainInput : false}
                    errorMessage={typeof errors?.otherDomainInput === 'string' ? errors.otherDomainInput : undefined}
                />
            )}

            <SelectField
                placeholder='Venture Stage'
                id='ventureStage'
                variant={componentSizeVariantsEnum.SMALL}
                required
                title='Venture Stage'
                label='Venture Stage'
                onSelection={(item: any) => setFieldValue('ventureStage', item.value)}
                selectedValue={values.ventureStage}
                options={ventureStageOptions}
                isTouched={typeof touched.ventureStage === 'boolean' ? touched.ventureStage : false}
                errorMessage={typeof errors?.ventureStage === 'string' ? errors.ventureStage : undefined}
            />
            <SelectField
                placeholder='Funding Stage'
                id='fundingStage'
                variant={componentSizeVariantsEnum.SMALL}
                required
                title='Funding Stage'
                label='Funding Stage'
                onSelection={(item: any) => setFieldValue('fundingStage', item.value)}
                selectedValue={values.fundingStage}
                options={fundingStageOptions}
                isTouched={typeof touched.fundingStage === 'boolean' ? touched.fundingStage : false}
                errorMessage={typeof errors?.fundingStage === 'string' ? errors.fundingStage : undefined}
            />
            {/* <SelectField
                placeholder='Incubation Center '
                id='incubatorName'
                variant={componentSizeVariantsEnum.SMALL}
                title='Incubator'
                label='Incubator'
                onSelection={(item: any) => setFieldValue('incubatorName', item.value)}
                selectedValue={values.incubatorName}
                options={IncubatorList?.map((item) => ({ id: item?.Name, label: item?.Name === 'Others' ? 'Others (Please specify)' : item?.Name, value: item?.Name }))}
            /> */}
            <SuggestionSelectField
                options={modifiedIncubatorList}
                value={incubatorValue || ''}
                placeholder="Incubation Center"
                label='Incubator'
                onChange={(selectedOption, actionMeata, e) => {
                    console.log(selectedOption, 'selectedOptionData');

                    setFieldValue('incubatorName', selectedOption?.value)
                }}
                variant={componentSizeVariantsEnum.SMALL}
            />
            {values?.incubatorName === 'Others' && (
                <InputField
                    label="Other Incubator Name"
                    id="otherIncubatorName"
                    value={values?.otherIncubatorName}
                    variant={componentSizeVariantsEnum.SMALL}
                    placeholder="Other Incubator Name"
                    type="text"
                    required={values?.incubatorName === 'Others'}
                    isTouched={typeof touched.otherIncubatorName === 'boolean' ? touched.otherIncubatorName : false}
                    errorMessage={typeof errors?.otherIncubatorName === 'string' ? errors.otherIncubatorName : undefined}
                />
            )}
            <SuggestionSelectField
                options={modifiedCoworkingList}
                value={coWorkingValue || ''}
                placeholder="Co-Working Space"
                label='Co-Working Space'
                onChange={(selectedOption, actionMeata, e) => {
                    setFieldValue('coWorkingName', selectedOption?.value)
                }}
                variant={componentSizeVariantsEnum.SMALL}
            />
            {/* <SelectField
                placeholder='Co-Working Space'
                id='coWorkingName'
                variant={componentSizeVariantsEnum.SMALL}
                title='Co-Working Space'
                label='Co-Working Space'
                onSelection={(item: any) => setFieldValue('coWorkingName', item.value)}
                selectedValue={values.coWorkingName}
                options={CoWorkerList?.map((item) => ({ id: item?.Name, label: item?.Name === 'Others' ? 'Others (Please specify)' : item?.Name, value: item?.Name }))}
            /> */}
            {values?.coWorkingName === 'Others' && (
                <InputField
                    label="Other Co-Working Space"
                    id="otherCoWorkingName"
                    value={values?.otherCoWorkingName}
                    variant={componentSizeVariantsEnum.SMALL}
                    placeholder="Other Co-Working Space"
                    type="text"
                    required={values?.coWorkingName === 'Others'}
                    isTouched={typeof touched.otherCoWorkingName === 'boolean' ? touched.otherCoWorkingName : false}
                    errorMessage={typeof errors?.otherCoWorkingName === 'string' ? errors.otherCoWorkingName : undefined}
                />
            )}
            <InputField
                label='Website URL'
                id="websiteUrl"
                value={values?.websiteUrl}
                variant={componentSizeVariantsEnum.SMALL}
                placeholder="https://"
                type="text"
            />

        </>
    )
}

export default BasicInfo;
